// empty (null-loader)